import { CryptoConsentStatus } from "../my-crypto-consent-status/myCryptoConsentStatus.types"

export enum CryptoConsentSource {
    LOGIN_POPUP = "LOGIN_POPUP",
    SIGN_UP = "SIGN_UP",
}

export type AcceptCryptoLegalDocData = {
    accessToken: string
    companyId?: string
    cryptoProviderTermsId: number
    source: CryptoConsentSource
}

export type AcceptCryptoLegalDocResponse = {
    data: {
        acceptCryptoLegalDoc: CryptoConsentStatus
    }
}
